// features/council/tones.ts — shared council display color literals (the accepted hardcoded-hex exception, single-sourced).
export const COUNCIL_KEEP = '#36e0a0';
export const COUNCIL_REMOVE = '#ff5ba6';
